import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { Icon } from "@circle-react-shared/Icon";
import type { Bookmark } from "./helpers/bookmark_helper";
import { truncatedBookmarkName } from "./helpers/bookmark_helper";

export interface FolderBookmarkButtonProps {
  bookmark?: Bookmark;
}

export const FolderBookmarkButton = ({
  bookmark,
}: FolderBookmarkButtonProps) => (
  <div className="flex select-none items-center gap-1 whitespace-nowrap px-1.5 py-1 pr-1 leading-none">
    <Typography.LabelSm weight="medium">
      {truncatedBookmarkName(bookmark)}
    </Typography.LabelSm>
    <span className="flex items-center">
      <Icon size={16} type="caret-down-bold" />
    </span>
  </div>
);
